import { ResourceManagerService } from './services/resource-manager.service';

export class ResourceSet {
  private static empty = new ResourceSet('');

  public static get Empty(): ResourceSet {
    return this.empty;
  }

  public constructor(public name: string) {}

  public svgName(key: string): string {
    if (!this.name) {
      return '';
    }
    return ResourceManagerService.getSvgName(this.name, key);
  }

  public svgUrl(key: string): string {
    if (!this.name) {
      return '';
    }
    return ResourceManagerService.getSvgUrl(this.name, key);
  }

  public get(key: string, ...values: string[]): string {
    if (!this.name) {
      return '';
    }
    return ResourceManagerService.getFormattedString(this.name, key, ...values);
  }
}
